import { AlertTitle, Collapse, Typography } from "@mui/material"
import { ReactElement } from "react"
import { FieldErrors } from "react-hook-form"

import AppAlert from "../dataDisplay/alerts/appAlert"

interface IFormErrorsProps {
    errors: FieldErrors<{
        [x: string]: object | undefined
    }>
    getFriendlyName: (key: string) => string | undefined
}

/** Component used to display errors returned by useForm() formState */
const FormErrors = ({
    errors,
    getFriendlyName,
}: IFormErrorsProps): ReactElement => (
    <Collapse in={Object.keys(errors).length > 0} mountOnEnter unmountOnExit>
        <AppAlert severity="warning">
            <AlertTitle>
                {Object.keys(errors).length > 1
                    ? `There are ${
                          Object.keys(errors).length
                      } things not quite right with your information`
                    : "There is one thing not quite right with your information"}
            </AlertTitle>
            <>
                {Object.entries(errors).map(([key, value]) => (
                    <Typography variant="body1" key={key}>
                        {getFriendlyName(key) ?? "Unknown"} -{" "}
                        <strong>{value?.message as string}</strong>
                    </Typography>
                ))}
            </>
        </AppAlert>
    </Collapse>
)

export default FormErrors
